import { Location } from 'history';
import { useCallback } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import { VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';
import { Prompt } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

const refetchVisitNecessary = (location: Location<unknown>): boolean => {
   return Boolean(
      matchPath(location.pathname, {
         path: [
            visitPaths.VISIT_INTERVIEW_PATH,
            visitPaths.PRESCRIPTIONS_PATH,
            visitPaths.DISCHARGE_SUMMARY_PATH,
            visitPaths.MEDICAL_LEAVE_PATH,
            visitPaths.ELECTRONIC_REFERRAL_TO_HOSPITAL_PATH,
            visitPaths.REFERRAL_TO_HOSPITAL_PATH,
            visitPaths.REFERRAL_TO_DIAGNOSTIC_EXAMINATION_PATH,
            visitPaths.ELECTRONIC_REFERRAL_TO_DIAGNOSTIC_EXAMINATION_PATH,
            visitPaths.REFERRAL_TO_PSYCHIATRIC_HOSPITAL_PATH,
            visitPaths.REFERRAL_TO_REHABILITATION_PATH,
            visitPaths.REFERRAL_TO_SPECIALIST_PATH,
            visitPaths.ELECTRONIC_REFERRAL_TO_SPECIALIST_PATH,
            visitPaths.VISIT_MEDICAL_DEVICES_PATH,
            visitPaths.MEDICAL_CERTIFICATE_PATH,
         ],
      })
   );
};

export const VisitRouteChangingGuard = (): JSX.Element | null => {
   const history = useHistory();
   const [{ setFalse: setInactive, setTrue: setActive }, active] = useBoolean(false);

   const handleMessage = useCallback(
      (nextLocation): boolean => {
         if (refetchVisitNecessary(nextLocation)) {
            const pushNextLocation = (): void => history.push(nextLocation);
            setActive();
            refetchCqrsQuery(VisitQuery).then(pushNextLocation).then(setInactive);
            return false;
         }

         return true;
      },
      [history, setActive, setInactive]
   );

   return <Prompt name={'visit'} when={!active} message={handleMessage} />;
};
